import { RootState } from "store";
import { IFlowFormState } from "store/reducers/formFlow";

import { createSelector } from "@reduxjs/toolkit";

import { getLatestInsuranceApplication } from "./getHasRUWCase";
import { getActiveStep } from "./getJourneyProgress";

const getDynamicFormFlow = (state: RootState) => state.dynamicForm.flow.slug;

const CO_BRANDED_FLOWS: IFlowFormState["slug"][] = [
  "beneficiary",
  "referral-partner",
  "estimate-form",
  "interview-question",
  "insurance-profile",
  "onboarding-intro",
  "underwriting-interview",
];

const CO_BRANDED_JOURNEY_STEPS = ["registration", "onboarding-intro"];

// Returns true if the current dynamic form flow is a co-branded flow.
// Callers should additionally check if the current pathname is "/fulfillment".
export const getIsCoBrandedFlow = createSelector(getDynamicFormFlow, flow =>
  CO_BRANDED_FLOWS.includes(flow)
);

// Returns true if the current journey step is a co-branded journey step and no insurance
// application exists yet. Callers should additionally check if the pathname is "/fulfillment".
export const getIsCoBrandedJourney = createSelector(
  getActiveStep,
  getLatestInsuranceApplication,
  (step, insuranceApplication) => {
    // Only consider it a co-branded journey if starting onboarding-intro from registration
    // Prevents co-branding showing when resuming fulfillment later in the journey (ie. quote-review)
    return CO_BRANDED_JOURNEY_STEPS.includes(step) && !insuranceApplication.id;
  }
);
